'use strict'

import * as types from '@/store/types.js'

const state = {
    id: null,
    menuItems: [],
    apiKey: null,
    referer: null
}

const mutations = {
    [types.APP.id.set]: (store, value) => {
        store.id = value
    },
    [types.APP.menuItems.set]: (store, value) => {
        store.menuItems = value
    },
    [types.APP.queue.set]: (store, value) => {
        store.queue = value
    },
    [types.APP.phone.set]: (store, value) => {
        store.phone = value
    },
    [types.APP.client.set]: (store, value) => {
        store.client = value
    },
    [types.APP.servicing.set]: (store, value) => {
        store.servicing = value
    },
    [types.APP.registration.set]: (store, value) => {
        store.registration = value
    },
    [types.APP.apiKey.set]: (store, value) => {
        store.apiKey = value
    },
    [types.APP.referer.set]: (store, value) => {
        store.referer = value
    }
}
const actions = {
    [types.APP.id.set](context, value) {
        context.commit(types.APP.id.set, value)
    },
    [types.APP.menuItems.set](context, value) {
        context.commit(types.APP.menuItems.set, value)
    },
    [types.APP.menuItems.set](context, value) {
        context.commit(types.APP.menuItems.set, value)
    },
    [types.APP.queue.set](context, value) {
        context.commit(types.APP.queue.set, value)
    },
    [types.APP.phone.set](context, value) {
        context.commit(types.APP.phone.set, value)
    },
    [types.APP.client.set](context, value) {
        context.commit(types.APP.client.set, value)
    },
    [types.APP.servicing.set](context, value) {
        context.commit(types.APP.servicing.set, value)
    },
    [types.APP.registration.set](context, value) {
        context.commit(types.APP.registration.set, value)
    },
    [types.APP.apiKey.set](context, value) {
        context.commit(types.APP.apiKey.set, value)
    },
    [types.APP.referer.set](context, value) {
        context.commit(types.APP.referer.set, value)
    }
}

export default {
    state,
    mutations,
    actions
}
